module.exports = __webpack_public_path__ + "img/ring_y_skip_1_0@3x.402eb4b2.png";